import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'
import ProductsLong from './ProductsLong.jsx'

import { translate } from 'react-i18next';

var SmallBusiness = React.createClass({

 getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
    window.scrollTo(0, 0);
    document.body.classList.add('long-scroll');
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  backToStepOne() {
    AvailabilityActions.backToStepOne();
  },

  selectProduct(product) {
      let select_to_signup = true;

      if(select_to_signup) {
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = this.state.store.get('signup_submit_target');

          var inputs = [
              ['srid', this.state.store.get('srid')],
              ['referral_code', this.state.store.get('referralCode')],
              ['coupon_code', (product.promo && product.promo.code ? product.promo.code : '')],
              ['prequal_key', this.state.store.get('prequal_tracking_key')],
              ['product_key', product.product_key],
              ['coupon_history', (window.coupon_history ? window.coupon_history : []) ],
              ['sso_user', this.state.store.get('sso_user')],
              ['sonic_elq_customerID', this.state.store.get('sonic_elq_customerID')],
          ];
          inputs.forEach(function(v) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = v[0];
              input.value = v[1];
              form.append(input);
          })

          document.body.append(form);
          form.submit();
          AvailabilityActions.placeOrder();
      }

    AvailabilityActions.selectProduct(product);
  },

  render() {
      const { t, show_voice_only } = this.props;
      var store = this.state.store;
      var products = store.get('products').toJS();
      let product = [];
      let coupon_banner = '';
      let otherProducts = false;
      let normalProductCount = 0;
      products.forEach(item=>{
        if (!item.product_key.match('voice')){
          product = item;
          normalProductCount++;
        } else {
          otherProducts = true;
        }
      })

      var displayPrice = parseFloat(product.mrc);
      let productRegularPrice = parseFloat(product.mrc);
      if(product.show_mrc_and_extra_fees_as_flat_rate) {
          let extraFeesTotal = product.extra_fees.reduce(function(carry, fee) {
              var feePrice = parseFloat(fee[1]);
              if(feePrice < 0) {
                  return carry;
              }
              carry += feePrice;
              return carry;
          }, 0.00);
          displayPrice += extraFeesTotal;
          productRegularPrice += extraFeesTotal;
      }
      var display_promo_amount = 0;
      var display_promo_duration = 0;


      if (product.promo && product.promo.hasOwnProperty('discount duration')) {
        display_promo_duration = product.promo['discount duration'];
      }
      var banner_addition = '';
      var promo_amount = 0;

      if(product.promo && product.promo.coupon_type_id && (product.promo.coupon_type_id == 38 || product.promo.coupon_type_id == 47)) {
          banner_addition = <div>Save $12 for 6 months on Whole-Home WiFi</div>;
      }
      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];
      }

      if(product.promo && product.promo['coupon type'] && product.promo['coupon type'] == 'free month') {
        coupon_banner = product.promo['description display'];
      }
        
      var qual_issue = '';
      if(store.get('sso_user')) {
        var qual_issue = <div style={{width:'150px', margin:'0px 0px 0px 10px', }}><a className="snc-btn snc-btn--sm" href={'https://sontec.sontrak.net/sontec-ng/ticket/create/qual/?prequal_key=' + store.get('prequal_tracking_key')} target="_blank">Qual Issue</a></div>
      }

      let prequal_key = '';
      if(store.get('sso_user')) {
        prequal_key = <div>Prequal Key: {store.get('async_id')}</div>
      }

      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];

        // all X month free promos under 1 year should show 10 off the display price
        if(promo_amount == 'free' || promo_amount == '6free' || promo_amount == '4free' || promo_amount == '3free' || promo_amount == '2free') {
            promo_amount = 10;
            display_promo_duration = '12 months';
        }
        else if(promo_amount == '12free') {
            promo_amount = 0;
            display_promo_duration = '12 months';
        } else {
            promo_amount = parseFloat(promo_amount);
        }
      }

      displayPrice =  Number(displayPrice - promo_amount).toFixed(2).replace('.00', '');
      productRegularPrice =  Number(productRegularPrice).toFixed(2).replace('.00', '');
      display_promo_amount = Number(promo_amount).toFixed(2).replace('.00', '');
      var qual_addr = store.get('qualified_address').toJS();
      var postal = store.get('postal_address').toJS();

      if(qual_addr.unit) {
        qual_addr.address = qual_addr.address + ', ' + qual_addr.unit;
      } else if (qual_addr.LocationValue1){
          qual_addr.address = (qual_addr.LocationDesignator1 ? qual_addr.address + ', ' + qual_addr.LocationDesignator1 + ' '+ qual_addr.LocationValue1 : qual_addr.address + ', ' + qual_addr.LocationValue1);
      }

    return (
<div>
    {(promo_amount == 0 ? "" :
    <div className="snc-section--signup-offer">
        <div className="container">
            <p className="offer">
                {(promo_amount == 0 ? "" : <span className="offer__special">Save ${(promo_amount)} for {(display_promo_duration)}</span>)}&nbsp;
                {((normalProductCount > 1 || promo_amount == 0) ? "" : <span className="offer__regular">({ ( t('common:regular_price').replace('{price}', productRegularPrice) )})</span>)}
                </p>
                <p className="coupon">
                <span className="coupon__detail">{( coupon_banner )}</span>
            </p>
        </div>
    </div>
    )}

    <div className="snc-section--signup-hero-business">
        <div className="container">
            <div className="snc-section-content">
                <h1>{t('common:small_business.great_news')}</h1>
                <p>{t('common:small_business.congrats')}</p>
                <div className="address">{t('common:we_found_addr')}<span className="address-only capitalize">{qual_addr.address.toLowerCase()}, {postal.city ? postal.city.toLowerCase() : ''} {qual_addr.state} {qual_addr.zip}</span>, Business (<a onClick={this.backToStepOne}>{t('common:change_address')}</a>)</div>
                { prequal_key }
            </div>
            <div>{ qual_issue }</div>
        </div>
    </div>

    <div className="snc-section--signup-cards">
        <div className="container">
            <div className="row">
                <ProductsLong />
            </div>
        </div>
    </div>

    <div className="snc-section--signup-business">
        <div className="container">
            <div className="list">
                <div className="list-item">
                    <div className="list-item-img">
                        <img
                            src="https://sonic.com/sites/default/files/icon-email-messaging.svg"
                            alt="Email/messaging icon"
                        />
                    </div>
                    <div className="list-item-desc">Email/Messaging</div>
                </div>
                <div className="list-item">
                    <div className="list-item-img">
                            <img
                                src="https://sonic.com/sites/default/files/icon-cloud-apps.svg"
                                alt="Cloud apps icon"
                            />
                    </div>
                    <div className="list-item-desc">Cloud Apps</div>
                </div>
                <div className="list-item">
                    <div className="list-item-img">
                        <img
                            src="https://sonic.com/sites/default/files/icon-video-conferencing.svg"
                            alt="Video conferencing icon"
                        />
                    </div>
                    <div className="list-item-desc">Video Conferencing</div>
                </div>
                <div className="list-item">
                    <div className="list-item-img">
                        <img
                            src="https://sonic.com/sites/default/files/icon-file-sharing.svg"
                            alt="File sharing icon"
                        />
                    </div>
                    <div className="list-item-desc">File Sharing</div>
                </div>
                <div className="list-item">
                    <div className="list-item-img">
                        <img
                            src="https://sonic.com/sites/default/files/icon-voip-phone.svg"
                            alt="VoIP phone icon"
                        />
                    </div>
                    <div className="list-item-desc">VoIP Phone</div>
                </div>
            </div>
            <div className="intro">
                <div className="row">
                    <div className="col-sm-6 col-md-5 col-md-offset-1">
                        <h2>{t('common:small_business.helping_head')}</h2>
                        <p>{t('common:small_business.helping_text')}</p>
                    </div>
                    <div className="col-sm-6 col-md-5">
                        <img
                            src="https://sonic.com/sites/default/files/photo-person-clipboard.jpeg"
                            alt="Small businesses making a big impact photo"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="snc-section--signup-customers">
        <div className="container">
            <h2>Our Customers Say it Best</h2>
            <div className="row">
                <div className="col-sm-4">
                    <div className="quote">
                    <p>Waiting for emails to send or for important documents to download is time I can’t afford to lose. Sonic is affordable and easy. I like to support the local business. Other ISPs in the area are not appealing.</p>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="quote">
                    <p>I first heard about Sonic from one of my teachers at Santa Rosa Junior College. I stay with Sonic not only for their awesome customer service, but also their dedication to the privacy of their members and an open Internet.</p>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="quote">
                    <p>I’m an early Sonic adopter, and a big believer in shopping local. Calling Sonic Tech support, I know I’m going to get a super competent and extremely nice young person who will solve my issue.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
    );
  }
});

export default  translate('common', { wait: true })(SmallBusiness);
